module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 111.eb390a3e.png";